import { GridColumn } from 'types/grid';

export const scheduleGridColumns: GridColumn[] = [
  { key: 'spacecraftName', title: 'Spacecraft', width: 140 },
  { key: 'groundStationName', title: 'Ground Station', width: 160 },
  { key: 'startTime', title: 'Start Time', width: 180 },
  { key: 'endTime', title: 'End Time', width: 180 },
  { key: 'availableTime', title: 'Available (sec)', width: 140 },
  { key: 'maxElevation', title: 'Max Elevation (°)', width: 150 },
  { key: 'status', title: 'Status', width: 120 }
];

export const downlinkFileGridColumns: GridColumn[] = [
  { key: 'downlinkDate', title: 'Downlink Date', width: 160 },
  { key: 'fileName', title: 'File Name', width: 200 },
  { key: 'fileSize', title: 'File Size (MB)', width: 120 },
  { key: 'downloadLink', title: 'Download', width: 140 }
];
